module.exports = __webpack_public_path__ + "img/voice-icon4.612be92.png";